<div class="box-border flex h-full min-h-full w-fit min-w-full flex-col">
  <div class="charting-history-card mat-elevation-z1 flex">
    @if (items$ | async; as items) {
      <pr-history-list
        [items]="items"
        [selected]="selectedItem$ | async"
        (selectedChange)="selectChartHistory($event)"
      />
      <div class="relative w-full p-2">
        @if (isOutOfSync$ | async) {
          <div
            class="absolute inset-[-16px] z-[1000] flex justify-center overflow-hidden bg-white/80 backdrop-blur"
          >
            <div class="mt-[16rem] flex flex-col items-center gap-2">
              <div class="flex items-center gap-2">
                <mat-icon>error_outline</mat-icon>
                <strong>Chart Out Of Sync</strong>
              </div>
              <span>
                Chart currently being edited in another tab.<br />
                Please sync to view the most recent changes.
              </span>
              <button mat-stroked-button (click)="syncChart()">
                <mat-icon>sync</mat-icon>
                Sync Chart
              </button>
            </div>
          </div>
        }

        <mat-tab-group
          mat-stretch-tabs="false"
          mat-align-tabs="start"
          [selectedIndex]="selectedChartTypeIndex$ | async"
          (selectedIndexChange)="setChartType($event)"
        >
          <mat-tab [label]="chartTypeOption.Clinical | titlecase">
            @if (items.length) {
              <pr-chart-ui class="px-2 py-4" [showHistorySelector]="false" />
            } @else {
              <div class="flex flex-col items-center justify-center">
                <div
                  class="charting-empty box-border flex h-full min-h-full w-full flex-col items-center justify-center gap-4"
                >
                  <pr-empty-state image="list" title="clinical charts" />
                  <pt-loader-button
                    type="flat"
                    color="primary"
                    [loading]="loading$ | async"
                    (click)="addFirstChart()"
                  >
                    Add First Chart
                  </pt-loader-button>
                </div>
              </div>
            }
          </mat-tab>
          <mat-tab [label]="chartTypeOption.Periodontal | titlecase">
            <div class="px-2 py-4">
              <pr-chart-view-toolbar
                [showHistorySelector]="false"
                [chartHistory]="items"
              >
                <pr-perio-chart-settings perioSettings [immutable]="false" />
              </pr-chart-view-toolbar>
              <pr-perio-chart-ui
                [chartHistory]="items"
                [chart]="(selectedItem$ | async)?.value"
              />
            </div>
          </mat-tab>
        </mat-tab-group>
      </div>
    }
  </div>
</div>
